import { Choice } from './choice.model'

/**
 * Represents an answer choice.
 */
export class Answer extends Choice {
  /** Tuple of answer choices. */
  tuple: unknown[] = []
  /** Indicates if the answer is a tuple. */
  isTuple = false
  /** Indicates if the answer is a selection. */
  isSelection = false
  /** Indicates if the answer has multiple choices. */
  isMultiple = false
  /** Number of choices in the answer. */
  count = 1

  /**
   * Creates an instance of Answer.
   * @param options - The options to initialize the answer.
   */
  constructor(options: Partial<Answer>) {
    super(options);
    if (!options) {
      return;
    }
    this.tuple = this.name.split('|')
    this.count = this.tuple.length
    this.isTuple = this.count > 0
    this.isMultiple = this.count > 1
    this.isSelection = this.isMultiple && Boolean(options.isSelection)
  }

  /**
   * Gets the URL of the text representation of the answer.
   * If the answer has multiple choices, concatenates them into a single string.
   * Otherwise, returns the text URL of the answer.
   */
  override get textUrl(): string {
    return this.isMultiple ? this.tuple.join('') : super.textUrl
  }
}
